module.exports = __webpack_public_path__ + "static/media/3DPPA18.bf18c68b.jpg";